module.exports = __webpack_public_path__ + "static/img/u60.45b9272a.png";